<!-- <div *ngIf="compraOld" class="overflow-hidden">
<div mat-dialog-title class="modal-title">
  <h1>{{'Comprar' | translate}} BRCs</h1>
  <a (click)="onNoClick()">X</a>
</div>
<div class="divider">
</div>
<div *ngIf="!isInformed && !data.isFromCarrinho" mat-dialog-content class="content">
  <h3>{{'Para começar: informe qual quantidade de créditos de carbono você deseja comprar' | translate}}?</h3>
  <div class="saldo d-flex flex-row">
    <h5>{{'Saldo atual' | translate}}:&#160;</h5>
    <h5 style="color: #287F3C;">{{data | currency:"":"":'1.2-3'}} BRCS</h5>
  </div>
  <mat-form-field class="w-75">
    <mat-label>{{'Quantidade de' | translate}} BRCs</mat-label>
    <input matInput [formControl]="brcFormControl" currencyMask [options]="{ prefix: 'BRC ', thousands: '.', decimal: ',', precision: 3 }">
  </mat-form-field>
  <mat-form-field *ngIf="!utilsCompraService.dadosUsuario.documento" class="w-75">
    <mat-label>CPF/CNPJ</mat-label>
    <input matInput [formControl]="documentoFormControl" mask="000.000.000-00||00.000.000/0000-00">
  </mat-form-field>
  <div class="calc">
    <h5>{{'Não sabe a quantidade que quer comprar' | translate}}?</h5>
    <div class="d-flex">
      <h4 class="nav-link p-0" routerLink="/calc-menu" (click)="onNoClick()">{{'Calcule aqui' | translate}}</h4>
    </div>
  </div>
  <div class="divider">
  </div>
  <div class="d-flex mt-2">
    <mat-checkbox [(ngModel)]="certificadoAutomatico">Emitir o certificado da compra?</mat-checkbox>
    <div class="alert alert-warning">
      <p class="m-0">**Marcando essa opção, o certificado será emitido imediatamente, com o valor total dos BRCs comprados</p>
      <p class="m-0">**Desmarcando essa opção, o saldo irá pra sua conta para a emissão posterior, no botão NOVO CERTIFICADO</p>
    </div>
  </div>
  <div class="buttons d-flex justify-content-end gap-2">
    <button type="button" class="btn btn-outline-success" (click)="onNoClick()">{{'Fechar' | translate}}</button>
    <button type="submit" class="btn btn-success" [disabled]="!brcFormControl.valid || brcFormControl.value < 1" (click)="brcQuantitySelected()">{{'Informar quantidade' | translate}}</button>
  </div>
</div>
<div *ngIf="!isInformed && data.isFromCarrinho" mat-dialog-content class="content">
  <div class="w-75">
    <h3>Ao neutralizar essa quantidade de <strong>{{data.quantidadeKgCo2 | currency:"":"":'1.2-3'}} Ton</strong> de CO2 você receberá <strong style="color: #287F3C;">{{data.quantidadeKgCo2 | currency:"":"":'1.2-3'}} BRCs</strong>
  </h3>

</div>
<mat-form-field *ngIf="!utilsCompraService.dadosUsuario.documento" class="w-75">
  <mat-label>CPF/CNPJ</mat-label>
  <input matInput [formControl]="documentoFormControl" mask="000.000.000-00||00.000.000/0000-00">
</mat-form-field>
<div class="calc">
  <h5>{{'Não sabe a quantidade que quer comprar' | translate}}?</h5>
  <h4 class="nav-link p-0" routerLink="/calc-menu" (click)="onNoClick()">{{'Calcule aqui' | translate}}</h4>
</div>
<div class="divider">
</div>
<div class="d-flex mt-2">
  <mat-checkbox [(ngModel)]="certificadoAutomatico">Emitir o certificado da compra?</mat-checkbox>
  <div class="alert alert-warning">
    <p>**Marcando essa opção, o certificado será emitido imediatamente, com o valor total dos BRCs comprados</p>
    <p>**Desmarcando essa opção, o saldo irá pra sua conta para a emissão posterior, no botão NOVO CERTIFICADO</p>
  </div>
</div>
<div class="buttons">
  <button type="button" class="btn btn-outline-success" (click)="onNoClick()">{{'Fechar' | translate}}</button>
  <button type="submit" class="btn btn-success" (click)="brcQuantitySelected()">Ir ao pagamento</button>
</div>
</div>
<div *ngIf="isInformed" mat-dialog-content class="content">
  <h3>{{'Agora, vamos para o pagamento' | translate}}!</h3>
  <p *ngIf="!credito && !pix">Selecione a sua forma de pagamento abaixo:</p>
  <div class="d-flex flex-start nav-pay justify-content-around">
    <a *ngIf="!credito" class="nav-link" [ngClass]="{'active': pix}" (click)="paymentType('pix')">Pix</a>
    <a *ngIf="!pix" class="nav-link" [ngClass]="{'active': credito}" (click)="paymentType('credito')">{{'Cartão de crédito' | translate}}</a>
  </div>
  <div *ngIf="pix" class="d-flex">
    <div *ngIf="qrcode" class="w-100 d-flex align-items-center flex-column">
      <qrcode [hidden]="qrcode===''" [qrdata]="qrcode" qrc-class="aclass" [errorCorrectionLevel]="'L'">
      </qrcode>
      <mat-form-field class="w-100">
        <mat-icon [disabled]="false" [cdkCopyToClipboard]="qrcode" matSuffix class="content-copy">content_copy</mat-icon>
        <input [disabled]="true" matInput [(ngModel)]="qrcode">
      </mat-form-field>
    </div>
  </div>
  <div *ngIf="credito">
    <mat-stepper linear="true" #stepper>
      <mat-step [stepControl]="editForm">
        <form [formGroup]="editForm" class="p-3">
          <ng-template matStepLabel>Dados do Pagamento</ng-template>
          <div class="d-flex gap-4">
            <mat-form-field class="w-100">
              <mat-label>{{'Nome' | translate}}</mat-label>
              <input matInput type="text" formControlName="nomecartao">
            </mat-form-field>
            <mat-form-field class="w-100">
              <mat-label>CPF/CNPJ</mat-label>
              <input matInput formControlName="documento" mask="000.000.000-00||00.000.000/0000-00">
            </mat-form-field>
          </div>
          <mat-form-field class="w-100">
            <mat-label>{{'Número do cartão' | translate}}</mat-label>
            <input matInput type="text" formControlName="cartao" mask="0000 0000 0000 0009">
          </mat-form-field>
          <div class="d-flex gap-4">
            <mat-form-field class="w-100">
              <mat-label>{{'Vencimento *Mês/Ano' | translate}}</mat-label>
              <input matInput type="text" formControlName="vencimento" mask="00/00">
            </mat-form-field>
            <mat-form-field class="w-100">
              <mat-label>CVV</mat-label>
              <input matInput type="text" formControlName="ccv" mask="0009">
            </mat-form-field>
          </div>
          <div class="buttons d-flex justify-content-end gap-2">
            <button class="btn btn-success" [disabled]="!editForm.valid" matStepperNext>Avançar</button>
          </div>
        </form>
      </mat-step>
      <mat-step [stepControl]="enderecoForm">
        <form [formGroup]="enderecoForm" class="p-3">
          <ng-template matStepLabel>Endereço</ng-template>
          <div class="d-flex gap-4">
            <mat-form-field class="w-100">
              <mat-label>CEP</mat-label>
              <input matInput type="text" formControlName="cep" minlength="8" maxlength="16" currencyMask [options]="{ prefix: '', thousands: '', decimal: ',', precision: 0 }">
            </mat-form-field>
            <mat-form-field class="w-100">
              <mat-label>Rua</mat-label>
              <input matInput type="text" formControlName="rua" maxlength="85">
            </mat-form-field>
          </div>
          <mat-form-field class="w-100">
            <mat-label>Bairro</mat-label>
            <input matInput type="text" formControlName="bairro" maxlength="85">
          </mat-form-field>
          <div class="d-flex gap-4">
            <mat-form-field class="w-100">
              <mat-label>Número</mat-label>
              <input matInput type="text" formControlName="numero" currencyMask [options]="{ prefix: '', thousands: '', decimal: ',', precision: 0 }" maxlength="85">
            </mat-form-field>
            <mat-form-field class="w-100">
              <mat-label>Complemento</mat-label>
              <input matInput type="text" formControlName="complemento" maxlength="128">
            </mat-form-field>
          </div>
          <div class="d-flex gap-4">
            <mat-form-field class="w-100">
              <mat-label>Cidade</mat-label>
              <input matInput type="text" formControlName="cidade">
            </mat-form-field>
            <mat-form-field class="w-100">
              <mat-label>Estado</mat-label>
              <mat-select formControlName="uf">
                <mat-option *ngFor="let estado of listOfEstados" [value]="estado.value">{{estado.value +' - '+estado.label}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="buttons d-flex justify-content-end gap-2">
            <button type="button" class="btn btn-outline-success" matStepperPrevious>{{'Voltar' | translate}}</button>
            <button class="btn btn-success" [disabled]="!enderecoForm.valid" matStepperNext>Avançar</button>
          </div>
        </form>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Confirmar</ng-template>
        <p>Deseja confirmar a compra?</p>
        <div class="buttons d-flex justify-content-end gap-2">
          <button type="button" class="btn btn-outline-success" matStepperPrevious>{{'Voltar' | translate}}</button>
          <button type="button" class="btn btn-success" [disabled]="!editForm.valid || !enderecoForm.valid" (click)="onSubmitCheckout()">{{'Confirmar' | translate}}</button>
        </div>
      </mat-step>
    </mat-stepper>
  </div>
</div>
</div> -->

<!-- NOVO -->
@if (!compraOld) {
  <div>
  <div mat-dialog-title>
  </div>
  <div mat-dialog-content>
  
    <div class="d-flex flex-column align-items-center container">
      <div class="alert alert-warning w-100">
        <p class="m-0" style="font-size: 20px;">**Antes de serem efetivadas as compras passam pelo processo de verificação e validação das informações prestadas e permitem ainda a identificação dos fornecedores do serviço ambiental segundo os critérios estabelecidos pelo comprador.
        </p>
        <br>
          <p class="m-0" style="font-size: 20px;">**Aguarde, você receberá nosso contato com os dados para o pagamento.</p>
        </div>
        @if (!utilsCompraService.dadosUsuario.documento) {
          <div class="w-100 pt-2">
            <div>
              <h6>{{'Para começar informe seu CPF/CNPJ' | translate}}:</h6>
              <mat-form-field  class="w-75">
                <mat-label>CPF/CNPJ</mat-label>
                <input matInput [formControl]="documentoFormControl" mask="000.000.000-00||00.000.000/0000-00">
              </mat-form-field>
            </div>
            <div class="buttons d-flex justify-content-end gap-2">
              <button type="button" class="btn btn-outline-success" (click)="onNoClick()">{{'Fechar' | translate}}</button>
              <button type="button" class="btn btn-success" (click)="documentSave()">{{'Continuar' | translate}}</button>
            </div>
          </div>
        }
        @if (utilsCompraService.dadosUsuario.documento || isInformed) {
          <div class="d-flex flex-column buttons w-75">
            <div class="btn-group" role="group">
              <button
                class="btn btn-outline-success w-50"
                [ngClass]="{'active-background' : currentCompensate, 'desactive-background': !currentCompensate}"
                (click)="compensateToCurrent()"
                >
                {{'Compensar para' | translate}} {{currentUser?.nome}}
              </button>
              <button
                class="btn btn-outline-success w-50"
                [ngClass]="{'active-background' : !currentCompensate, 'desactive-background': currentCompensate}"
                (click)="compensateToOther()"
                >
                {{'Compensar para outra pessoa' | translate}}
              </button>
            </div>
            <div class="content pt-3">
              <div class="d-flex align-items-center gap-2 mt-2">
                <mat-checkbox [(ngModel)]="certificadoAutomatico">Emitir o certificado na compra?</mat-checkbox>
                <div class="d-flex flex-column alert alert-warning">
                  <p class="m-0">**Marcando essa opção, o certificado será emitido imediatamente, com o valor total dos BRCs</p>
                  <p class="m-0">**Desmarcando essa opção, o saldo irá para sua conta, podendo fazer a emissão do certifiado depois.</p>
                </div>
              </div>
              <form [formGroup]="projetoForm" (ngSubmit)="save()">
                <div class="d-flex flex-column">
                  <div class="d-flex flex-column">
                    <div class="alert alert-info">
                      <p class="m-0" style="font-size: 20px;">1 BRC = 1 Tonelada {{'de' | translate}} CO2 retirada da atmosfera</p>
                    </div>
                    <mat-form-field>
                      <mat-label>{{'Pegada de CO2 em' | translate}} BRC</mat-label>
                      <input formControlName="calculo" currencyMask [options]="{ prefix: 'BRC ', thousands: '.', decimal: ',', precision:3 }" matInput type="text" placeholder="BRC">
                    </mat-form-field>
                    <div class="calc">
                      <h5>{{'Não sabe a quantidade que quer comprar' | translate}}?</h5>
                      <div class="d-flex">
                        <h4 routerLink="/calc-menu" (click)="onNoClick()" class="nav-link p-0">{{'Calcule aqui' | translate}}</h4>
                        <h6>&nbsp;ou&nbsp;</h6>
                        <h4 routerLink="/site/faleconosco" (click)="onNoClick()" class="nav-link p-0">{{'Solicite uma reunião' | translate}}.</h4>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex flex-column pt-3">
                    <h5>{{'Dados para o projeto de compensação:' | translate}}</h5>
                    @if (!currentCompensate) {
                      <mat-form-field>
                        <mat-label>{{'Nome ou Nome Fantasia(PJ)' | translate}}</mat-label>
                        <input formControlName="nome" matInput>
                      </mat-form-field>
                    }
                    @if (!currentCompensate) {
                      <mat-form-field>
                        <mat-label>{{'Razão Social' | translate}}</mat-label>
                        <input formControlName="razaoSocial" matInput>
                      </mat-form-field>
                    }
                    @if (!currentCompensate) {
                      <mat-form-field>
                        <mat-label>{{'Email' | translate}}</mat-label>
                        <input formControlName="email" matInput>
                      </mat-form-field>
                    }
                    @if (!currentCompensate) {
                      <mat-form-field>
                        <mat-label>{{'telefone' | translate}}</mat-label>
                        <input formControlName="telefone" matInput mask="(00) 0000-0000||(00) 0 0000-0000">
                      </mat-form-field>
                    }
                    <mat-form-field>
                      <mat-label>{{'Titulo do projeto' | translate}}</mat-label>
                      <input formControlName="titulo" matInput placeholder="Caso não haja Projeto deixar em branco">
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>{{'Objetivo' | translate}}</mat-label>
                      <textarea matInput formControlName="observacao" placeholder="Exemplo: Qual será o produto ou serviço a ser compensado"></textarea>
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>{{'Lotes ou Período' | translate}}</mat-label>
                      <textarea matInput formControlName="descricao" placeholder="Exemplo: Emissão de carbono do ano de 2023, segundo inventário de Carbono realizado..."></textarea>
                    </mat-form-field>
                    @if (!currentCompensate) {
                      <mat-form-field>
                        <mat-label>CPF/CNPJ</mat-label>
                        <input formControlName="cpfCnpj" matInput mask="000.000.000-00||00.000.000/0000-00">
                      </mat-form-field>
                    }
                  </div>
                </div>
                <div class="divider pb16">
                </div>
                <div class="buttons d-flex gap-2 justify-content-end pb-3">
                  <button type="submit" class="btn btn-success" [disabled]="!projetoForm.valid">{{'Enviar informações' | translate}}</button>
                </div>
              </form>
            </div>
          </div>
        }
      </div>
    </div>
    </div>
  }
